/** CSMS endpoint roles for Organization External CSMS configuration. */
export const CsmsEndpointRole = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export type CsmsEndpointRole =
  (typeof CsmsEndpointRole)[keyof typeof CsmsEndpointRole];

export const CSMS_ENDPOINT_ROLE_VALUES: CsmsEndpointRole[] = [
  CsmsEndpointRole.PRIMARY,
  CsmsEndpointRole.SECONDARY,
];

export const MAX_CSMS_ENDPOINTS = 5;
export const MAX_CSMS_SECONDARIES = 4;
